// Transpiler for older browsers
import "core-js/stable";

import Vue from "vue";
import VModal from "vue-js-modal";

import store from "@/store";

import HttpService from "./services/http";

import VueNotification from "./libs/vue-notification/src";
import SimpleVueValidation from "simple-vue-validator";
import VueScrollTo from "vue-scrollto";
import VTooltip from "v-tooltip";
import VueMasonry from "vue-masonry-css";

import { formatDate } from "./filters/filters";
import DigitalEventRouter from "@/router/DigitalEventRouter";
import DigitalEvent from "@/DigitalEvent";

import "./style.less";
import "video.js/dist/video-js.css";

import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { initPrototypes } from "@/helpers/prototypes";
import { vFocus, vClickOutside } from "@/helpers/directives";

import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

import Preloader from "@/components/DigitalEvent/common/Preloader";

Vue.component("digital-event-preloader", Preloader);

dayjs.extend(isToday);
dayjs.extend(utc);
dayjs.extend(timezone);

initPrototypes();

/** Global filters */
Vue.filter("formatDate", formatDate);

/** Global directives */
Vue.directive("focus", vFocus);
Vue.directive("click-outside", vClickOutside);

Vue.use(Viewer);
Vue.use(VueNotification);
Vue.use(VModal, { dialog: true });
Vue.use(SimpleVueValidation);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 700,
  easing: "ease-in-out",
  offset: 0,
  force: false,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(VTooltip);
Vue.use(VueMasonry);

Vue.config.devtools = true; // TODO: only for dev mode
Vue.config.productionTip = false;

Vue.use({
  install(Vue) {
    Vue.prototype.$http = HttpService;
  }
});

if (document.getElementById("ev-digital-event")) {
  // Check user, then get room context depending on user auth state
  store
    .dispatch("event/getConfig", {
      uuid: document.getElementById("ev-digital-event").dataset.uuid
    })
    .then(() => {
      store.dispatch("users/checkUserSession").then(() => {
        store.dispatch("event/getContext", { includeChildren: 0 }).then(() => {
          new Vue({
            store,
            router: DigitalEventRouter,
            render: h => h(DigitalEvent)
          }).$mount("#ev-digital-event");
        });
      });
    });
}
